// Modules
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { connect } from 'react-redux';
import alarm from 'assets/audio/alarm.mp3';

// Services
import { registerSocket, deregisterSocket } from 'services/socket';
import Triage from 'services/data/triage';

// Actions
import { update, eagerUpdate } from './store/actions';

// Components
import TriageItem from 'components/models/triage/triage-items';
import FlipMove from 'components/widgets/animation/flip-move';

// Constants
import { isMobile } from 'constants';

// Utils
import newTriageAlert from 'utils/new-triage-alert';


class TriageList extends React.Component {
  static propTypes = {
    items: PropTypes.array,
    activeTab: PropTypes.string
  };

  componentDidMount() {
    registerSocket('triage', _.debounce(update, 500, { leading: true }));
  }

  componentDidUpdate(prevProps) {
    newTriageAlert(prevProps.items, this.props.items);
  }

  componentWillUnmount() {
    deregisterSocket('triage');
  }
  
  render() {
    const { items } = this.props;
    const { active = [], resolved = [] } = _(items)
      .orderBy([Triage.getSortKey], ['desc'])
      .groupBy(item => (_.includes(['Active', 'After Hours'], item.status) ? 'active' : 'resolved'))
      .value();

    const resolvedWithDivider = resolved.length && active.length ? _.concat([], { triageId: 'divider', title: 'Resolved' }, resolved) : resolved;
    const toRender = _.concat(active, resolvedWithDivider);
    const duration = isMobile ? 200 : 500;

    return (
      <div className="triage-items">
        <audio id="triage-audio" src={alarm} autoPlay={false} ></audio>
        <FlipMove duration={duration}>
          {_.map(toRender, (item) => {
            if (item.triageId === 'divider') return <div key={item.title} className="divider-title">{item.title}</div>;

            return (
              <div key={item.triageId} >
                <TriageItem item={item} eagerUpdate={eagerUpdate} />
              </div>
            );
          })}
        </FlipMove>
      </div>
    );
  }
}

// Exports
export default connect((state) => ({
  items: state.triage.items
}))(TriageList);



// WEBPACK FOOTER //
// ./app/modules/triage/triage-list.js